import { Link, NavigateFunction, useNavigate } from "react-router-dom";
import { ConfigProvider, Menu } from "antd";
import { NAVBAR_ITEMS_KEYS } from "@Constants/navbar";
import { NavigationRoutes } from "../../navigation/NavigationRoutes";
import ManufacturerIcon from "@Assets/icons/manufacturer.svg";
import ManufacturerIconActive from "@Assets/icons/manufacturerActive.svg";
import OrderIcon from "@Assets/icons/order.svg";
import OrderIconActive from "@Assets/icons/orderYellow.svg";
import DashboardIcon from "@Assets/icons/dashboardIcon.svg";
import DashboardIconActive from "@Assets/icons/dashboardIconActive.svg";
import CustomerIcon from "@Assets/icons/customer.svg";
import CustomerIconActive from "@Assets/icons/customerActive.svg";
import PricingIcon from "@Assets/icons/pricing.svg";
import PricingIconActive from "@Assets/icons/pricingActive.svg";
import SubAdminIcon from "@Assets/icons/sub-admin.svg";
import SubAdminIconActive from "@Assets/icons/sub-admin-active.svg";
import VerificationIcon from "@Assets/icons/verificationCheck.svg";
import VerificationIconActive from "@Assets/icons/verificationCheckActive.svg";
import ProductRequestIcon from "@Assets/icons/productRequest.svg";
import ProductRequestIconActive from "@Assets/icons/productRequestActive.svg";
import Logo from "@Assets/images/Frame.png";
import "./index.scss";

const navItemsClassActive = "font-Inter text-app-red";
const navItemsClassInactive = "!font-Inter !text-app-secondary !font-medium ";
const iconWrapperClass = "w-5 h-5 flex items-center justify-center";

const SideBar = ({
  route,
  selectedKey,
}: {
  route: string[];
  selectedKey: string;
  navigate: NavigateFunction;
}) => {
  const sidebarMenu = [
    {
      key: NAVBAR_ITEMS_KEYS.DASHBOARD,
      label: (
        <Link
          to={NavigationRoutes.DASHBOARD_ROUTES.DASHBOARD}
          className={
            selectedKey === NAVBAR_ITEMS_KEYS.DASHBOARD
              ? navItemsClassActive
              : navItemsClassInactive
          }
        >
          Dashboard
        </Link>
      ),
      icon:
        selectedKey === NAVBAR_ITEMS_KEYS.DASHBOARD ? (
          <div className={iconWrapperClass}>
            <DashboardIconActive />
          </div>
        ) : (
          <div className={iconWrapperClass}>
            <DashboardIcon />
          </div>
        ),
    },
    {
      key: NAVBAR_ITEMS_KEYS.USER_MANAGEMENT,
      label: (
        <Link
          to={NavigationRoutes.DASHBOARD_ROUTES.USER_MANAGEMENT}
          className={
            selectedKey === NAVBAR_ITEMS_KEYS.USER_MANAGEMENT
              ? navItemsClassActive
              : navItemsClassInactive
          }
        >
          User Management
        </Link>
      ),
      icon:
        selectedKey === NAVBAR_ITEMS_KEYS.USER_MANAGEMENT ? (
          <div className={iconWrapperClass}>
            <OrderIconActive />
          </div>
        ) : (
          <div className={iconWrapperClass}>
            <OrderIcon />
          </div>
        ),
    },
    {
      key: NAVBAR_ITEMS_KEYS.VERIFICATION_MANAGEMENT,
      label: (
        <Link
          to={NavigationRoutes.DASHBOARD_ROUTES.VERIFICATION_MANAGEMENT}
          className={
            selectedKey === NAVBAR_ITEMS_KEYS.VERIFICATION_MANAGEMENT
              ? navItemsClassActive
              : navItemsClassInactive
          }
        >
          User Verifications
        </Link>
      ),
      icon:
        selectedKey === NAVBAR_ITEMS_KEYS.VERIFICATION_MANAGEMENT ? (
          <div className={iconWrapperClass}>
            <VerificationIconActive />
          </div>
        ) : (
          <div className={iconWrapperClass}>
            <VerificationIcon />
          </div>
        ),
    },
    {
      key: NAVBAR_ITEMS_KEYS.BOOKINGS_MANAGEMENT,
      label: (
        <Link
          to={NavigationRoutes.DASHBOARD_ROUTES.BOOKINGS_MANAGEMENT}
          className={
            selectedKey === NAVBAR_ITEMS_KEYS.BOOKINGS_MANAGEMENT
              ? navItemsClassActive
              : navItemsClassInactive
          }
        >
          Booking Management
        </Link>
      ),
      icon:
        selectedKey === NAVBAR_ITEMS_KEYS.BOOKINGS_MANAGEMENT ? (
          <div className={iconWrapperClass}>
            <CustomerIconActive />
          </div>
        ) : (
          <div className={iconWrapperClass}>
            <CustomerIcon />
          </div>
        ),
    },
    {
      key: NAVBAR_ITEMS_KEYS.WITHDRAWAL_MANAGEMENT,
      label: (
        <Link
          to={NavigationRoutes.DASHBOARD_ROUTES.WITHDRAWAL_MANAGEMENT}
          className={
            selectedKey === NAVBAR_ITEMS_KEYS.WITHDRAWAL_MANAGEMENT
              ? navItemsClassActive
              : navItemsClassInactive
          }
        >
          Withdrawal Requests
        </Link>
      ),
      icon:
        selectedKey === NAVBAR_ITEMS_KEYS.WITHDRAWAL_MANAGEMENT ? (
          <div className={iconWrapperClass}>
            <ManufacturerIconActive />
          </div>
        ) : (
          <div className={iconWrapperClass}>
            <ManufacturerIcon />
          </div>
        ),
    },

    {
      key: NAVBAR_ITEMS_KEYS.DISPUTES_MANAGEMENT,
      label: (
        <Link
          to={NavigationRoutes.DASHBOARD_ROUTES.DISPUTES_MANAGEMENT}
          className={
            selectedKey === NAVBAR_ITEMS_KEYS.DISPUTES_MANAGEMENT
              ? navItemsClassActive
              : navItemsClassInactive
          }
        >
          Dispute Management
        </Link>
      ),
      icon:
        selectedKey === NAVBAR_ITEMS_KEYS.DISPUTES_MANAGEMENT ? (
          <div className={iconWrapperClass}>
            <PricingIconActive />
          </div>
        ) : (
          <div className={iconWrapperClass}>
            <PricingIcon />
          </div>
        ),
    },
    {
      key: NAVBAR_ITEMS_KEYS.REVIEWS_MANAGEMENT,
      label: (
        <Link
          to={NavigationRoutes.DASHBOARD_ROUTES.REVIEWS_MANAGEMENT}
          className={
            selectedKey === NAVBAR_ITEMS_KEYS.REVIEWS_MANAGEMENT
              ? navItemsClassActive
              : navItemsClassInactive
          }
        >
          Review Management
        </Link>
      ),
      icon:
        selectedKey === NAVBAR_ITEMS_KEYS.REVIEWS_MANAGEMENT ? (
          <div className={iconWrapperClass}>
            <SubAdminIconActive />
          </div>
        ) : (
          <div className={iconWrapperClass}>
            <SubAdminIcon />
          </div>
        ),
    },
    {
      key: NAVBAR_ITEMS_KEYS.PRODUCT_REQUESTS,
      label: (
        <Link
          to={NavigationRoutes.DASHBOARD_ROUTES.PRODUCT_REQUESTS_MANAGEMENT}
          className={
            selectedKey === NAVBAR_ITEMS_KEYS.PRODUCT_REQUESTS
              ? navItemsClassActive
              : navItemsClassInactive
          }
        >
          Product Requests
        </Link>
      ),
      icon:
        selectedKey === NAVBAR_ITEMS_KEYS.PRODUCT_REQUESTS ? (
          <div className={iconWrapperClass}>
            <ProductRequestIconActive />
          </div>
        ) : (
          <div className={iconWrapperClass}>
            <ProductRequestIcon />
          </div>
        ),
    },
  ];

  const navigate = useNavigate();

  return (
    <div className="w-[var(--side-bar-width)] min-w-[var(--side-bar-width)] max-w-[var(--side-bar-width)] !bg-white h-full text-left navbar-items border-r z-10 border-app-border flex flex-col">
      <div className="flex flex-col justify-between h-full flex-1 overflow-hidden">
        <div
          className="cursor-pointer flex-shrink-0 pl-4 text-right flex items-center justify-center pt-6 mb-2"
          onClick={() => navigate(NavigationRoutes.DASHBOARD_ROUTES.DASHBOARD)}
        >
          <img src={Logo} width={150} height={70} alt="Local Locker Logo" />
        </div>

        <div className="flex-1 overflow-y-auto py-4 !font-Inter">
          <ConfigProvider
            theme={{
              components: {
                Menu: {
                  itemSelectedBg: "var(--color-app-light-red)",
                  itemSelectedColor: "var(--color-app-red)",
                  itemMarginInline: 8,
                  itemMarginBlock: 9,
                  itemHeight: 46,
                  itemBorderRadius: 12,
                  itemHoverBg: "var(--color-app-light-gray)",
                },
              },
            }}
          >
            <Menu
              mode="inline"
              theme={"light"}
              className="!font-Inter !text-[1rem] sidebar-menu"
              items={sidebarMenu.map((item) => ({
                key: item.key,
                icon: item.icon,
                label: item.label,
              }))}
              selectedKeys={route.length ? [selectedKey] : ["dashboard"]}
            />
          </ConfigProvider>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
